/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useService } from '../../../../services/services';
import { route } from '../../../../services/utils';
import { LIVESTOCK_ANIMALS_AND_EVENTS_INDEX } from '../../../../router/routes';
import { FormMode } from '../../../../enums/form-mode';
import { SubmitType } from '../../../../components/form';
import AnimalsAndEventsTabsKeys from '../enums/animals-and-events-tab-keys';
import { useQuery } from '../../../../hooks/use-query';

export function useFormDestroy() {
  const { farmId, id } = useParams<{
    farmId: string;
    id: string;
  }>();
  const [queries] = useQuery();

  const history = useHistory();
  const { animalEventService } = useService();

  return useCallback<SubmitType<any>>(() => {
    return [
      animalEventService.destroy(farmId, id),
      () => {
        history.push(
          route(LIVESTOCK_ANIMALS_AND_EVENTS_INDEX, {
            tab: queries.to === AnimalsAndEventsTabsKeys.events
              ? AnimalsAndEventsTabsKeys.events
              : AnimalsAndEventsTabsKeys.animals,
            farmId,
            mode: FormMode.edit,
          })
        );
      },
    ];
  }, []);
}
